// GlobalModal.js
import React, { useState, useEffect } from "react";
import { useModal } from "../helpers/ModalContext";
import { X } from "lucide-react";
import Logo from "../assets/logo.png";
export default function GameModal() {
  const { isOpen, game, closeModal } = useModal();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Reset loading state when a new game is opened
    if (isOpen) {
      setIsLoading(true);
    }
  }, [isOpen, game]);

  const handleIframeLoad = () => {
    // Wait additional time after iframe loads for game content to fully render
    setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3 seconds delay after iframe loads
  };

  if (!isOpen || !game) return null;

  return (
    <div className="global-modal">
      <div className="p-2">
        <img src={Logo} width={70} />
        <button
          className="btn btn-primary"
          style={{ float: "right" }}
          onClick={closeModal}
        >
          Close <X size={22} />
        </button>
      </div>
      {isLoading && (
        <div className="game-loader">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      )}
      <iframe
        src={game.Content}
        title={game.Title}
        style={{ width: "100%", height: "100%", border: "none" }}
        onLoad={handleIframeLoad}
      />
    </div>
  );
}
